import styled from "styled-components";
import zIndexTypes from "../../../theme/zIndexTypes";
import {
  mediaMaxHeight,
  mediaMinWidth,
  mediaMaxWidth,
} from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div``;

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxHeight.phone`
    align-items: unset;
  `}

  ${mediaMaxWidth.tablet`
    align-items: unset;
  `}
`;

export const EditModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
  height: ${(props) => (props.iOS ? "530px" : "580px")};
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop`
    margin-left: unset;
    width: calc(100vw - 30px);
  `}

  ${mediaMaxWidth.tablet`
    top: 10px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 20px);
    padding: 10px 10px;
    height: ${(props) =>
      props.iOS ? "calc(100vh - 20px)" : "calc(100vh - 20px)"};
  `}

  ${mediaMaxHeight.phone`
    top: 10px;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop`
    width: 95%;
  `}
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const StepButtons = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 500px;
  top: 8px;

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
    background-color: #fff;
    z-index: 1;
    padding: 10px 0;
    top: 0;
  `}
`;

export const PrevButton = styled.div`
  position: relative;
  width: 100px;
  z-index: 3;
  height: 40px;
  width: 40px;
  background-color: #79D9D9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease-in-out;
  cursor: pointer;

  svg {
    color: #fff;
  }

  &:hover {
    background-color: #402680;
  }
`;

export const NextButton = styled.div`
  position: relative;
  width: 100px;
  z-index: 3;
  text-align: right;
  margin-left: auto;
  height: 40px;
  width: 40px;
  background-color: #79D9D9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease-in-out;
  cursor: pointer;

  svg {
    color: #fff;
  }

  &:hover {
    background-color: #402680;
  }
`;

export const Loading = styled.img`
  position: absolute;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 550px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
  `}
`;
Form.displayName = "Form";

export const CurrentComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${mediaMaxWidth.phone`
    height: ${(props) =>
      props.iOS ? "calc(100vh - 225px)" : "calc(100vh - 160px)"};
    flex: unset;
    display: unset;
    padding-bottom: 100px;
    overflow-y: auto;
    position: relative;
    top: 60px;
  `}
`;

export const SectionTitle = styled.div`
  z-index: 2;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 15px 0;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth.phone`
    position: fixed;
    right: 0;
    left: 0;
    width: 225px;
    margin: 0 auto;
    height: 60px;
    top: 70px;
    display: flex;
    align-items: center;
  `}
`;

export const Label = styled.label`
  display: flex;
  font-size: 0.9em;
  height: 20px;
  margin-top: ${(props) => props.marginTop && `${props.marginTop}px`};
  position: relative;
  justify-content: space-between;

  &:first-of-type {
    margin-top: 5px;
  }
`;

export const Field = styled.div`
  position: relative;
  flex: ${(props) => props.location && "2"};
  margin-right: ${(props) => props.location && "15px"};
  margin-bottom: ${(props) => props.infoField && "20px"};

  ${mediaMaxWidth.phone`
    width: ${(props) => props.postCode && "120px"};
  `}
`;

export const Error = styled.div`
  position: ${(props) => (props.positionRelative ? "relative" : "absolute")};
  bottom: 0;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 600;
`;
Error.displayName = "Error";

export const LabelText = styled.div`
  position: relative;
`;

export const LabelIcon = styled.div`
  svg {
    cursor: pointer;
  }

  .__react_component_tooltip.show {
    max-width: 300px;
  }
`;

export const Required = styled.span`
  font-weight: 400;
  font-size: 1.5em;
  position: absolute;
  top: -5px;
  right: -15px;
  color: #79D9D9;
`;

export const Input = styled.input`
  display: flex;
  border: ${(props) =>
    props.error ? "2px solid #79D9D9" : "2px solid #e7e7e7"};
  border-radius: 4px;
  width: 100%;
  resize: none;
  padding: 10px;
  position: relative;
  margin: 5px 0 15px 0;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const SelectWrapper = styled.div`
  margin: 5px 0 20px 0;

  .react-select-container {
    z-index: 2;
    border: ${(props) =>
      props.error ? "2px solid #79D9D9" : "2px solid #fff"};
  }

  .react-select__control {
    border-width: 2px;
    border-color: #e7e7e7;
    cursor: pointer;

    &.react-select__control--is-focused,
    &.react-select__control--menu-is-open {
      border-color: #79D9D9;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }

    svg {
      color: #79D9D9;
    }
  }
`;

export const Select = styled.select`
  background-color: #fff;
  border: ${(props) =>
    props.error ? "2px solid #79D9D9" : "2px solid #e7e7e7"};
  height: 46px;
  width: 100%;
  margin: 5px 0 20px 0;
  padding: 0 5px;
  border-radius: 4px;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const Option = styled.option``;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: ${(props) => (props.iOS ? "78px" : "28px")};
  left: 0;
  right: 0;

  button {
    margin: 5px 10px 25px 10px;

    ${mediaMaxWidth.phone`
      margin: 5px 10px 5px 10px;
    `}
  }

  ${mediaMaxWidth.phone`
    background: #fff;
    z-index: 1;
    position: fixed;
    bottom: 10px;
    height: 70px;
    align-items: center;
    left: unset;
    right: unset;
    width: calc(100vw - 55px);
  `}
`;

export const EditorWrapper = styled.div`
  margin: 10px 0;
  position: relative;

  ${Error} {
    bottom: -20px;
  }

  .editor-toolbar {
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    margin-bottom: 15px;
    height: 60px;

    .rdw-option-wrapper {
      border: 2px solid #fff;
      border-radius: 4px;
      height: 30px;
      width: 35px;

      &:hover {
        border: 2px solid #402680;
        box-shadow: none;
      }
    }

    .rdw-option-wrapper.rdw-option-active {
      border: 2px solid #402680;
      box-shadow: none;

      &:hover {
        border: 2px solid #402680;
        box-shadow: none;
      }
    }
  }

  .editor {
    max-height: 240px;
    padding: 10px;
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    min-height: 15em;

    .public-DraftStyleDefault-block {
      margin: 0;
    }

    &:focus {
      border-color: #79D9D9;
      outline: none;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }
`;
EditorWrapper.displayName = "EditorWrapper";

export const CheckBoxesGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  margin-bottom: 20px;

  ${mediaMaxWidth.phone`
    flex-flow: unset;
    flex-direction: column;
    margin-bottom: 30px;
  `}
`;

export const CheckBoxesGroupItem = styled.div`
  display: flex;
  flex-direction: row;
  width: 50%;
  margin: 5px 0 10px 0;

  ${mediaMaxWidth.phone`
    width: 100%;
  `}
`;

export const Indicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 4px;
  background: #fff;
  border: 2px solid #e7e7e7;
  transition: 0.1s ease-in-out;

  &:after {
    content: "\f00c ";
    font-family: FontAwesome;
    position: absolute;
    top: -4px;
    left: 0;
    color: #fff;
  }

  &:hover {
    border: 2px solid #402680;
  }
`;

export const CheckBoxWrap = styled.div`
  display: flex;
  margin: 5px 0 10px 0;
`;

export const CheckBoxInput = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:checked ~ ${Indicator} {
    background: #79D9D9;
    border: 2px solid #79D9D9;

    &:after {
      display: block;
    }
  }
`;

export const CheckBoxLabel = styled.label`
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-weight: 400;
`;

export const Check = styled.div`
  display: block;
  position: absolute;
  left: 0;
  border: 3px solid #e7e7e7;
  border-radius: 100%;
  height: 20px;
  width: 20px;
  transition: border 0.25s linear;

  &:before {
    display: block;
    position: absolute;
    content: "";
    border-radius: 100%;
    height: 10px;
    width: 10px;
    top: 2px;
    left: 2px;
    margin: auto;
    transition: background 0.1s linear;
  }
`;

export const RadioButtonGroup = styled.ul`
  display: flex;
  margin: 5px 0 30px 0;
  padding: 0;
`;

export const RadioButtonWrapper = styled.li`
  display: flex;
  flex: 1;
  align-items: center;
  position: relative;
  top: 5px;
  margin: 10px 0px;
  transition: 0.1s ease-in-out;

  &:hover {
    ${Check} {
      border: 3px solid #402680;
    }
  }
`;

export const RadioButton = styled.input`
  margin: -3px 0 0 !important;
  position: absolute;
  visibility: hidden;

  &:checked ~ ${Check} {
    border: 3px solid #79D9D9;
  }

  &:checked ~ ${Check}::before {
    background: #79D9D9;
  }

  &:checked ~ label {
    color: #79D9D9;
  }
`;

export const RadioButtonLabel = styled.label`
  font-weight: 400;
  position: absolute;
  left: 0;
  padding: 0 30px;
  z-index: 1;
  transition: 0.1s ease-in-out;
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    color: #402680;
  }
`;

export const ContractDuration = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DurationElement = styled.div`
  display: flex;
  flex-direction: column;

  &:nth-child(1) {
    flex: 2;
  }

  &:nth-child(2) {
    margin-left: 20px;
    flex: 5;
  }
`;

export const AgencyFee = styled.div`
  display: flex;
  flex-direction: row;

  ${Label} {
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

export const AgencyFeeElement = styled.div`
  display: flex;
  flex-direction: column;

  &:nth-child(1) {
    flex: 4;
  }

  &:nth-child(2) {
    flex: 1;
    margin: 0 10px;
    justify-content: center;
    align-items: center;
    font-weight: 700;
  }

  &:nth-child(3) {
    flex: 4;
  }
`;

export const Salary = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;

  ${Label} {
    &:first-of-type {
      margin-top: 0;
    }
  }
`;

export const SalaryElement = styled.div`
  display: flex;
  flex-direction: column;

  &:nth-child(1) {
    flex: 4;
  }

  &:nth-child(2) {
    flex: 1;
    margin: 0 10px;
    justify-content: center;
    align-items: center;
    font-weight: 700;
  }

  &:nth-child(3) {
    flex: 4;
  }
`;

export const MustHavesInputWrapper = styled.div`
  .react-tagsinput {
    background-color: #fff;
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    padding: 10px;
    min-height: 46px;
    margin-bottom: 20px;

    &:hover {
      border-color: #79D9D9;
      outline: none;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  .react-tagsinput--focused {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  .react-tagsinput-tag {
    background-color: #402680;
    border-radius: 2px;
    border: 1px solid #402680;
    color: #fff;
    display: inline-block;
    font-size: 15px;
    font-weight: 400;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 1px 5px;
  }

  .react-tagsinput-remove {
    cursor: pointer;
    font-weight: bold;
    margin-left: 10px;

    &:before {
      content: "x";
      color: #79D9D9;
      font-size: 13px;

      &:hover {
        color: #79D9D9;
      }
    }
  }

  .react-tagsinput-input {
    border: none;
    display: block;
    width: 100%;

    &:focus {
      outline: none;
    }
  }
`;

export const Location = styled.div`
  display: flex;
  justify-content: space-between;
`;
